// ============================================================
// notificationChime.ts — the short in-app chime for a new bell notification
// (NotificationsBell; per-user toggle notificationPreferences
// .soundOnNotification, default OFF). Synthesised with the Web Audio API —
// two soft sine tones, ~0.35s — so there's no audio file to ship or load.
// Plays only while Casevo is open; browsers allow audio once the user has
// interacted with the page, which is always the case in-app. Any failure
// (no Web Audio, audio blocked) is silent — a chime is never worth an error.
// ============================================================
let ctx: AudioContext | null = null

export const playNotificationChime = (): void => {
  try {
    const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
    if (!AC) return
    ctx = ctx ?? new AC()
    if (ctx.state === 'suspended') void ctx.resume()
    const now = ctx.currentTime
    const tone = (freq: number, start: number, length: number): void => {
      const osc = ctx!.createOscillator()
      const gain = ctx!.createGain()
      osc.type = 'sine'
      osc.frequency.value = freq
      // Quick fade in / out so it's a soft "ding", not a click.
      gain.gain.setValueAtTime(0, now + start)
      gain.gain.linearRampToValueAtTime(0.12, now + start + 0.02)
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + length)
      osc.connect(gain).connect(ctx!.destination)
      osc.start(now + start)
      osc.stop(now + start + length + 0.02)
    }
    tone(880, 0, 0.18)
    tone(1318.5, 0.12, 0.24)
  } catch { /* audio unavailable / blocked — stay silent */ }
}
